/** Provedores e modelos que as telas de IA oferecem. Outro modelo pode ser digitado. */
export const PROVIDERS = [
  { value: 'anthropic', label: 'Anthropic', hint: 'Claude' },
  { value: 'openai', label: 'OpenAI', hint: 'GPT' },
  { value: 'ollama', label: 'Ollama', hint: 'Local, sem chave' },
];

export const MODELS = {
  anthropic: [
    { id: 'claude-haiku-5-5', label: 'Claude Haiku 5.5', input: 0.1, output: 0.5 },
    { id: 'claude-sonnet-5-5', label: 'Claude Sonnet 5.5', input: 2, output: 10 },
    { id: 'claude-opus-5-5', label: 'Claude Opus 5.5', input: 4, output: 20 },
  ],
  openai: [
    { id: 'gpt-5-mini', label: 'GPT-5 mini' },
    { id: 'gpt-5', label: 'GPT-5' },
  ],
  ollama: [],
};

export function providerLabel(p) {
  return PROVIDERS.find(x => x.value === p)?.label || p || '';
}

export function modelLabel(id) {
  for (const list of Object.values(MODELS)) {
    const m = list.find(x => x.id === id);
    if (m) return m.label;
  }
  return id || '';
}

/** "sk-ant-••••4f2a" a partir dos 4 últimos caracteres. */
export function maskedKey(provider, last4) {
  if (!last4) return '';
  const prefix = provider === 'anthropic' ? 'sk-ant-' : provider === 'openai' ? 'sk-' : '';
  return `${prefix}••••••••••••${last4}`;
}

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const usd = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' });
export const fmtBRL = (v) => brl.format(Number.isFinite(v) ? v : 0);
export const fmtUSD = (v) => usd.format(Number.isFinite(v) ? v : 0).replace('US$', 'US$ ').replace(/\s+/, ' ');
export const fmtInt = (v) => Math.round(v || 0).toLocaleString('pt-BR');

/** 41.100.000 → "41,1 M"; 4000 → "4,0k". */
export function fmtCompact(v, { k = 'k' } = {}) {
  const n = Number(v) || 0;
  if (n >= 1e6) return `${(n / 1e6).toLocaleString('pt-BR', { maximumFractionDigits: 1, minimumFractionDigits: 1 })} M`;
  if (n >= 1000) return `${(n / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1, minimumFractionDigits: 1 })}${k}`;
  return fmtInt(n);
}

/** Estimativa de uma revisão de artigo (tokens). Ajustar com o real. */
export const REVIEW_TOKENS_IN = 8000;
export const REVIEW_TOKENS_OUT = 1200;

/**
 * Calculadora de uso e custo do mês.
 * chat = pessoas × msgs × dias; calls = chat + revisões; tokens e custo pelos preços por 1M.
 */
export function estimate({ people, msgs, days, reviews, tin, tout, pin, pout, fx, cap, limit }) {
  const chat = people * msgs * days;
  const calls = chat + reviews;
  const tokIn = chat * tin + reviews * REVIEW_TOKENS_IN;
  const tokOut = chat * tout + reviews * REVIEW_TOKENS_OUT;
  const usdMonth = (tokIn * pin + tokOut * pout) / 1e6;
  const brlMonth = usdMonth * fx;
  const perDay = days > 0 ? calls / days : 0;
  const capPct = cap > 0 ? (calls / cap) * 100 : 0;
  const overDay = cap > 0 && calls > cap && perDay > 0 ? Math.ceil(cap / perDay) : null;
  const suggested = people > 0 && days > 0 ? Math.max(0, Math.floor((cap - reviews) / (people * days))) : null;
  // Pior caso: todo mundo no limite diário, todos os dias
  const worstChat = people * limit * days;
  const worstUsd = ((worstChat * tin + reviews * REVIEW_TOKENS_IN) * pin + (worstChat * tout + reviews * REVIEW_TOKENS_OUT) * pout) / 1e6;
  return {
    chat, calls, tokIn, tokOut, tokens: tokIn + tokOut, usdMonth, brlMonth,
    perPerson: people > 0 ? brlMonth / people : 0,
    perDay, brlPerDay: days > 0 ? brlMonth / days : 0,
    capPct, overDay, suggested, worstBrl: worstUsd * fx,
  };
}

/** "há 3 min" a partir de uma data ISO. */
export function ago(iso) {
  if (!iso) return '';
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const min = Math.round(diff / 60000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.round(h / 24);
  return `há ${d} ${d === 1 ? 'dia' : 'dias'}`;
}
